"use client";
import {
  useMenuContext
} from "./A22SDPU3.js";
import {
  useMenubarContext
} from "./ZPGENCAP.js";
import {
  useComboboxProviderContext
} from "./3L4UCDWT.js";
import {
  useCompositeStoreProps
} from "./WH6Q5C3D.js";
import {
  useHovercardStoreProps
} from "./IOEKCBMU.js";
import {
  useStore,
  useStoreProps
} from "./DTNGDFNU.js";
import {
  useUpdateEffect
} from "./OPTPHWV7.js";
import {
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/menu/menu-store.ts
import * as Core from "@ariakit/core/menu/menu-store";
function useMenuStoreProps(store, update, props) {
  useUpdateEffect(update, [props.combobox, props.parent, props.menubar]);
  useStoreProps(store, props, "values", "setValues");
  return Object.assign(
    useHovercardStoreProps(
      useCompositeStoreProps(store, update, props),
      update,
      props
    ),
    {
      combobox: props.combobox,
      parent: props.parent,
      menubar: props.menubar
    }
  );
}
function useMenuStore(props = {}) {
  const parent = useMenuContext();
  const menubar = useMenubarContext();
  const combobox = useComboboxProviderContext();
  props = __spreadProps(__spreadValues({}, props), {
    parent: props.parent !== void 0 ? props.parent : parent,
    menubar: props.menubar !== void 0 ? props.menubar : menubar,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  });
  const [store, update] = useStore(Core.createMenuStore, props);
  return useMenuStoreProps(store, update, props);
}

export {
  useMenuStoreProps,
  useMenuStore
};
